import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950/95 backdrop-blur-md border-b border-background-800/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 no-underline group">
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-fill text-background-50 text-lg"></i>
            </span>
            <span className="text-xl font-heading text-foreground-950 font-bold group-hover:text-primary-400 transition-colors whitespace-nowrap">
              奇优影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                isActive('/') && !isActive('/category') && !isActive('/detail') && !isActive('/about')
                  ? 'bg-primary-500 text-background-950'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-800'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/movie"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                isActive('/category/movie')
                  ? 'bg-primary-500 text-background-950'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-800'
              }`}
            >
              电影
            </Link>
            <Link
              to="/category/tv"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                isActive('/category/tv')
                  ? 'bg-primary-500 text-background-950'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-800'
              }`}
            >
              电视剧
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-500 text-background-950'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-800'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-700 hover:bg-background-800 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-b border-background-800/50">
          <div className="px-4 py-4 flex flex-col gap-2">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-800 transition whitespace-nowrap">首页</Link>
            <Link to="/category/movie" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-800 transition whitespace-nowrap">电影</Link>
            <Link to="/category/tv" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-800 transition whitespace-nowrap">电视剧</Link>
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-800 transition whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}